import * as Sentry from '@sentry/react';
import I18N from '@leverege/i18n';
import Molten from '@leverege/molten';
import { Context } from '@leverege/plugin';
import { Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { AllowedReducer, Constants } from '@leverege/api-redux';
const {
  t,
  tIcon
} = I18N.ns('recovr.details.refreshLocationCache.RefreshLocationCacheAction');
const ACTION = 'refreshLocationCache';
export default {
  id: 'recovr.locationCache.refresh',
  name: 'Refresh Location Cache',
  matches: [{
    client: ['DataCardDetail'],
    use: 'actionBar',
    objectType: 'location'
  }],
  isPrepared: context => {
    const targets = Context.getTargetsOfType(context, 'location');
    if (targets == null || targets.length === 0 || targets.length > 1) {
      return true;
    }
    const location = targets[0];
    const locationId = location.id;
    const a = AllowedReducer.get(GlobalState.get(), locationId);
    return a[ACTION] != null;
  },
  prepare: async context => {
    const targets = Context.getTargetsOfType(context, 'location');
    if (targets == null || targets.length === 0 || targets.length > 1) {
      return false;
    }
    const location = targets[0];
    const locationId = location.id;
    const systemId = Molten.getConfig('api/systemId');
    return GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      try {
        const res = await api.system(systemId).srv('r4kactions').post('refreshLocationCache', {}, {
          test: true
        });
        dispatch({
          type: Constants.ALLOWED_SET,
          resourceId: locationId,
          action: ACTION,
          allowed: res.allowed === true
        });
        return res.allowed === true;
      } catch (err) {
        Sentry.captureException(err);
        console.error(err);
        return false;
      }
    });
  },
  handles: context => {
    const targets = Context.getTargetsOfType(context, 'location');
    if (targets == null || targets.length === 0 || targets.length > 1) {
      return false;
    }
    const location = targets[0];
    const locationId = location.id;
    const a = AllowedReducer.get(GlobalState.get(), locationId);
    return a[ACTION] === true;
  },
  appearance: ({
    context
  }) => {
    const targets = Context.getTargetsOfType(context, 'location');
    const location = targets && targets[0];
    const keysEnabled = location?.data?.data?.keysEnabled;
    return {
      disabled: !keysEnabled,
      name: t('name'),
      icon: tIcon('icon')
    };
  },
  perform: ({
    context
  }) => {
    GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      try {
        const systemId = Molten.getConfig('api/systemId');
        const response = await api.system(systemId).srv('r4kactions').post('refreshLocationCache', {}, {});
        Toast.success([t('success'), response?.message]);
      } catch (err) {
        Sentry.captureException(err);
        console.error(err);
        Toast.error([t('error'), err?.message]);
      }
    });
  }
};